import React from "react";
import { BsInstagram, BsGithub, BsLinkedin, BsTwitter } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://github.com/faisaditya">
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/faisaditya">
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://twitter.com/faisadityaa">
          <BsTwitter />
        </a>
      </div>
      <div>
        <a href="https://www.instagram.com/faisaditya/">
          <BsInstagram />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
